import type { InternalService } from '@percent/admin-dashboard/api/actions/internalServices/internalServices.types'
import { CreateServiceModal } from './CreateServiceModal'
import { DeleteServiceModal } from './DeleteServiceModal'
import { EditServiceModal } from './EditServiceModal'

export type ServiceModalState =
  | { kind: 'create' }
  | { kind: 'edit'; service: InternalService }
  | { kind: 'delete'; service: InternalService }
  | null

type ServiceModalProps = {
  modal: ServiceModalState
  onClose: () => void
  /** After a service is created or edited. */
  onChanged: () => void
  onDeleted: () => void
}

/** Whichever service modal is open, mounted only while it is, so each opens with a fresh form. */
export function ServiceModal({ modal, onClose, onChanged, onDeleted }: Readonly<ServiceModalProps>) {
  switch (modal?.kind) {
    case 'create':
      return <CreateServiceModal onClose={onClose} onCreated={onChanged} />
    case 'edit':
      return <EditServiceModal service={modal.service} onClose={onClose} onEdited={onChanged} />
    case 'delete':
      return <DeleteServiceModal service={modal.service} onClose={onClose} onDeleted={onDeleted} />
    default:
      return null
  }
}
